// BH-RAPP-001 (LC-BRAND-001, operator-ratified 2026-06-20): the Rev9 Labs
// entity-separation disclaimer, Variant B — VERBATIM from
// legal/drafts/2026-06-20-rev9-entity-disclaimer.md §B. KEEP-VERBATIM: the
// string below is legally load-bearing and pinned by
// api/apps/portfolio/tests/test_entity_disclaimer_copy.py — never reword,
// trim, or "improve" it without a new ratified draft. Single-sourced here;
// every chrome renders this component.
export const ENTITY_DISCLAIMER_VARIANT_B =
  'Rev9 Labs builds software; it is not an investment firm, fund, or adviser, '
  + 'and does not provide investment advice or manage capital. The financial '
  + 'services these tools support are run by separate businesses (e.g. Rev9 '
  + 'Capital, n8 Capital). Naming a product describes software, not a '
  + 'financial offering.';

// Small/dim legal-line treatment matching the existing footer register.
export function EntityDisclaimer({ style }: { style?: React.CSSProperties }) {
  return (
    <p style={{
      margin: '12px 0 0', fontSize: 11, lineHeight: 1.55,
      color: 'var(--ink-3)', maxWidth: '92ch', ...style,
    }}>
      {ENTITY_DISCLAIMER_VARIANT_B}
    </p>
  );
}
